import m from "../../../../geodata/es2015/region/world/northAmericaLow";
window.am4geodata_region_world_northAmericaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/northAmericaLow.js
// module id = null
// module chunks = 